"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 
 * 
 * Lookup to determine what props we include in style
 *
 * For now this is limited purely to style rules dealing with
 * layout and sizing (cur. box & text layout).
 */
exports.default = {
  alignItems: true,
  alignContent: true,
  alignSelf: true,
  borderWidth: true,
  borderTopWidth: true,
  borderRightWidth: true,
  borderBottomWidth: true,
  borderLeftWidth: true,
  display: true,
  cursor: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  justifyContent: true,
  order: true,
  padding: true,
  paddingTop: true,
  paddingRight: true,
  paddingBottom: true,
  paddingLeft: true,
  margin: true,
  marginTop: true,
  marginRight: true,
  marginBottom: true,
  marginLeft: true,
  position: true,
  top: true,
  right: true,
  bottom: true,
  left: true,
  width: true,
  height: true,
  minWidth: true,
  minHeight: true,
  maxWidth: true,
  maxHeight: true,
  float: true,
  zIndex: true,
  overflow: true,
  overflowX: true,
  overflowY: true,
  tableLayout: true,
  verticalAlign: true,
  textAlign: true,
  textAlignLast: true,
  textIndent: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  wordBreak: true,
  wordSpacing: true,
  wordWrap: true,
  lineHeight: true,
  boxSizing: true
};


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/utils/style/style-whitelist.js
// module id = 365
// module chunks = 114276838955818